import React from 'react';
import Icon, {IconSize} from '../../../ui/Icon/Icon';
import {GenericIconName} from '../../../ui/Icon/IconName';
import {ErrorIconWrapper, ModalText, ModalTitle} from '../ProductReview.styled';
import {useProductReviewTranslations} from '../context/ProductReviewTranslationsProvider';

const ErrorMessage: React.FC = () => {
  const {errorModalTitle, errorModalDescription} =
    useProductReviewTranslations();
  return (
    <>
      <ErrorIconWrapper>
        <Icon asset={GenericIconName.IcCross} size={IconSize.M} />
      </ErrorIconWrapper>
      <ModalTitle data-testid="review-modalTitle-error">
        {errorModalTitle}
      </ModalTitle>
      <ModalText data-testid="review-modalDesc-error">
        {errorModalDescription}
      </ModalText>
    </>
  );
};

export default ErrorMessage;
